import { Component, Input } from '@angular/core';
import {
  IonCard,
  IonCol,
  IonLabel,
  IonRow,
  IonText,
} from '@ionic/angular/standalone';
import { IOption } from 'src/app/components/shared/form/components/form-select/form-select.component';

@Component({
  selector: 'app-details-card',
  imports: [IonLabel, IonText, IonRow, IonCol, IonCard],
  templateUrl: './details-card.component.html',
  styleUrl: './details-card.component.scss',
})
export class DetailsCardComponent {
  @Input() data!: IOption[];
  @Input() size!: number;
}
